import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from "lucide-react";
import { title } from "process";
interface SocialLinksProps {
  settings: {
    facebook_url?: string;
    twitter_url?: string;
    instagram_url?: string;
    youtube_url?: string;
    linkedin_url?: string;
  };
}

const SocialLinks = ({ settings }: SocialLinksProps) => {
  const socials = [
    {
      url:
        settings.facebook_url ||
        "https://www.facebook.com/p/Haryana-Olympic-Association-61574667794025" ||
        "#",
      name: "Facebook",
      icon: <Facebook className="h-5 w-5" />,
      hover: "hover:text-blue-500",
      color: "text-blue-500 border-blue-500",
      variant: "outline",
    },
    {
      url: settings.twitter_url || "https://x.com/Haryana_olympic" || "#",
      name: "Twitter",
      icon: <Twitter className="h-5 w-5" />,
      hover: "hover:text-blue-500",
      color: "text-blue-500 border-blue-500",
      variant: "outline",
    },
    {
      url:
        settings.instagram_url ||
        "https://www.instagram.com/haryanaolympicassociation" ||
        "#",
      name: "Instagram",
      icon: <Instagram className="h-5 w-5" />,
      hover: "hover:text-pink-500",
      color: "text-pink-500 border-pink-500",
      variant: "outline",
    },
    {
      url:
        settings.youtube_url ||
        "https://www.youtube.com/@HaryanaOlympicAssociation" ||
        "#",
      name: "Youtube",
      icon: <Youtube className="h-5 w-5" />,
      hover: "hover:text-red-500",
      color: "text-red-500 border-red-500",
      variant: "outline",
    },
    {
      url:
        settings.linkedin_url ||
        "https://in.linkedin.com/company/haryanaolympicassociation" ||
        "#",
      name: "Linkedin",
      icon: <Linkedin className="h-5 w-5" />,
      hover: "hover:text-blue-500",
      color: "text-blue-500 border-blue-500",
      variant: "outline",
    },
  ];

  return (
    <div className="flex space-x-3 md:justify-start justify-center">
      {socials.map(
        (social, index) =>
          social.url && (
            <Link
              key={index}
              to={social.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                size="lg"
                variant={social.variant as "outline" | "ghost"}
                className={`${social.color} ${social.hover} p-2`}
                title={`${social.name}`}
              >
                {social.icon}
              </Button>
            </Link>
          ),
      )}
    </div>
  );
};

export default SocialLinks;
